<template>
  <div>
    <section class="business-bg">
      <div class="container shape-container pt-md-5">
        <div class="pt-md-5">
          <div class="col-lg-8 pt-5">
            <div class="row">
              <h3 class="display-3 mt-5">
                Launch Your Own Fintech Business with TopupBox
              </h3>
              <p class="lead text-dark mt-0">
                Have a fintech idea? Want to start your own airtime, data, or
                utility payment platform? TopupBox builds custom web and mobile
                apps <br />
                for entrepreneurs and businesses who want to enter the fintech
                <br />
                space without the heavy cost of building from scratch.
              </p>
              <!-- buttons -->
              <div class="mt-3 d-flex gap-2">
                <router-link to="/register" class="btn btn-info">
                  Start My Fintech Now
                </router-link>
                <button class="btn btn-info" @click="showSalesModal = true">
                  Talk to sales
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--talk to sales Modal -->
    <modal
      :show.sync="showSalesModal"
      modal-classes="modal-dialog-centered modal-sm"
    >
      <!-- header slot -->
      <template #header>
        <h5 class="modal-title">Talk to Sales</h5>
      </template>

      <!-- body slot -->
      <div class="">
        <p class="footer-header d-flex align-items-center" style="gap: 8px">
          <img src="img/icons/common/email.svg" alt="" style="width: 25px" />
          <a href="mailto:sales@topupbox.com">Sales@topupbox.com</a>
        </p>
        <p
          class="footer-header d-flex align-items-center gap-4"
          style="gap: 8px"
        >
          <img
            src="img/icons/common/telephone.png"
            alt=""
            style="width: 25px"
          />
          <a href="tel:+2348123456789">+234 808 3972 277</a>
        </p>
      </div>
    </modal>

    <section class="section px-lg-0 px-4">
      <div class="container">
        <div class="row row-grid align-items-center pb-md-5">
          <div
            class="col-md-6 order-md-2"
            data-aos="fade-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="1000"
          >
            <div class="pl-md-5">
              <div class="mb-4">
                <img src="img/icons/common/enterprise.svg" class="img-fluid" />
              </div>
              <p class="lead mb-5 text-default">
                Why Choose TopupBox for Your Business?
              </p>
              <ul>
                <li class="py-2">
                  <span class="footer-header">
                    Ready-to-Use Infrastructure
                  </span>
                  - We provide the technology backbone so you can focus on
                  growing your brand.
                </li>
                <li class="py-2">
                  <span class="footer-header"> Custom Web & Mobile Apps </span>
                  - Get a platform designed for your business, built to your
                  requirements.
                </li>
                <li class="py-2">
                  <span class="footer-header">Speed to Market </span>
                  - Go live faster with TopupBox’s proven systems.
                </li>
                <li class="py-2">
                  <span class="footer-header"> Scalable Services </span> - From
                  airtime and data to utilities and bill payments, expand your
                  offerings as you grow.
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6 order-md-1">
            <img
              src="img/theme/people-shaking.png"
              class="img-fluid rounded shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
    <!-- our simple process -->
    <section class="pb-5 px-lg-0 px-4">
      <div class="container">
        <div class="text-center justify-content-center">
          <div class="col-lg-12">
            <h2 class="display-3 text-default mb-5">Our Simple Process</h2>
          </div>
        </div>
        <div class="row justify-content-center mb-4">
          <div class="col-lg-12">
            <div
              class="row row-grid"
              data-aos="fade-up"
              data-aos-easing="ease-out-cubic"
              data-aos-duration="1000"
            >
              <!--  Share Your business details  -->
              <div class="col-lg-4 d-flex">
                <card
                  class="border-0 text-center w-100 h-100"
                  shadow
                  body-classes=""
                >
                  <div class="mb-4 d-flex justify-content-center">
                    <i class="ni ni-folder-17 display-3 text-primary"></i>
                  </div>

                  <h6 class="text-primary text-uppercase display-4 w-100">
                    Share Your business details
                  </h6>

                  <p class="description mt-3">
                    Tell us your business name and details
                  </p>
                </card>
              </div>

              <!-- We Build for You-->
              <div class="col-lg-4 d-flex">
                <card
                  class="border-0 text-center w-100 h-100"
                  shadow
                  body-classes=""
                >
                  <div class="mb-4 d-flex justify-content-center">
                    <i class="ni ni-ruler-pencil display-3 text-primary"></i>
                  </div>

                  <h6 class="text-primary text-uppercase display-4 w-100">
                    We Build for You
                  </h6>

                  <p class="description mt-3">
                    Our team designs and develops your fintech web app or mobile
                    app.
                  </p>
                </card>
              </div>

              <!-- Launch & Grow-->
              <div class="col-lg-4 d-flex">
                <card
                  class="border-0 text-center w-100 h-100"
                  shadow
                  body-classes=""
                >
                  <div class="mb-4 d-flex justify-content-center">
                    <i class="ni ni-spaceship display-3 text-primary"></i>
                  </div>

                  <h6 class="text-primary text-uppercase display-4 w-100">
                    Launch & Grow
                  </h6>

                  <p class="description mt-3">
                    Enter the fintech space fully equipped to attract, serve,
                    and scale with your own customers.
                  </p>
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- what you get -->
    <section class="values-section pb-5 pt-lg-0 px-lg-0 px-4">
      <div class="container">
        <div class="container pt-lg">
          <div class="row text-center justify-content-center">
            <div class="col-lg-10">
              <h2 class="display-3 text-dark">What You Get</h2>
            </div>
          </div>

          <div class="row row-grid mt-5 text-center">
            <!-- branded business -->
            <div class="col-lg-3">
              <div class="mb-4">
                <i class="ni ni-badge text-primary display-3"></i>
              </div>

              <h5 class="text-dark mt-3">Branded Platform</h5>

              <p class="mt-3 lead-2">Your app, your logo, your identity.</p>
            </div>
            <!-- All Core Services -->
            <div class="col-lg-3">
              <div class="mb-4">
                <i class="ni ni-collection text-primary display-3"></i>
              </div>

              <h5 class="text-dark mt-3">All Core Services</h5>

              <p class="mt-3 lead-2">
                Airtime, data, utilities, and more built-in.
              </p>
            </div>
            <!-- API-Driven  -->
            <div class="col-lg-3">
              <div class="mb-4">
                <i class="ni ni-laptop text-primary display-3"></i>
              </div>

              <h5 class="text-dark mt-3">API-Driven</h5>

              <p class="mt-3 lead-2">
                Powered by robust APIs for reliability and speed.
              </p>
            </div>
            <!-- End-to-End Support -->
            <div class="col-lg-3">
              <div class="mb-4">
                <i class="ni ni-support-16 text-primary display-3"></i>
              </div>

              <h5 class="text-dark mt-3">End-to-End Support</h5>

              <p class="mt-3 lead-2">
                From setup to scaling, we’ve got you covered.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import Modal from "../../components/Modal.vue";
export default {
  components: { Modal },
  data() {
    return {
      showSalesModal: false,
    };
  },
};
</script>
